// ============================================================================
// ChatTranscript — текст расшифровки ПОД голосовым сообщением (Telegram-стиль):
// свёрнут до 1–2 строк, «показать полностью» разворачивает. Правка — обычным
// механизмом сообщения (messenger.editMessage), правится ТОЛЬКО текст.
// ============================================================================

import { useState } from 'react';
import { MentionRichText } from '@/components/chat/MentionRichText';
import { transcriptNeedsToggle } from '@/lib/voice/chatTranscript';
import { useI18n } from '@/lib/i18n/I18nProvider';

export function ChatTranscript({ text, mine, mentionLogins, myLogin, highlightQuery }: {
  text: string;
  mine: boolean;
  mentionLogins?: string[];
  myLogin?: string;
  highlightQuery?: string;
}) {
  const { t } = useI18n();
  const [expanded, setExpanded] = useState(false);
  const collapsible = transcriptNeedsToggle(text);

  return (
    <div
      className={`mt-1 min-w-0 max-w-full border-l-2 pl-2 ${
        mine ? 'border-primary/40' : 'border-muted-foreground/40'
      }`}
      data-chat-transcript
    >
      <div
        className={`whitespace-pre-wrap text-[12.5px] italic leading-snug opacity-85 [overflow-wrap:anywhere] ${
          collapsible && !expanded ? 'line-clamp-2' : ''
        }`}
      >
        <MentionRichText
          text={text}
          logins={mentionLogins || []}
          myLogin={myLogin}
          mine={mine}
          highlight={highlightQuery}
        />
      </div>
      {collapsible && (
        <button
          type="button"
          className="mt-0.5 text-[10px] font-medium text-primary underline"
          onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
        >
          {expanded ? t('chat.transcript_collapse') : t('chat.transcript_show_full')}
        </button>
      )}
    </div>
  );
}
